<mat-card appearance="outlined" [attr.data-test-id]="'module-card-' + config.guid">
  <mat-card-header>
    <mat-card-title>
      {{ config.headline }}
    </mat-card-title>
    <mat-card-subtitle>
      @if (config.filter.enabled) {
        <div class="data-filtered-message">
          <mat-icon>warning</mat-icon> {{ "app.dailyDataFiltered" | translate }}
        </div>
      }
    </mat-card-subtitle>
    <div class="ml-auto">
      <button mat-button [matMenuTriggerFor]="correlationContextMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #correlationContextMenu="matMenu">
        <button mat-menu-item (click)="exportCurrentView($event)">
          {{ "app.exportView" | translate }} <mat-icon>file_download</mat-icon>
        </button>
      </mat-menu>
    </div>
  </mat-card-header>

  <mat-card-content class="relative">
    @if (isLoading) {
      <div data-test-id="module-loading-spinner">
        <ngx-spinner
          [fullScreen]="false"
          type="ball-scale-multiple"
          size="medium"
          >
        </ngx-spinner>
      </div>
    }
    <div class="flex flex-row" [ngStyle]="{ width: chartWidth }">
      <canvas
        #chart
        id="chart"
        baseChart
        [datasets]="chartData"
        [type]="'scatter'"
        [plugins]="chartPlugins"
        [options]="chartOptions"
        (window:resize)="onChartResize($event)"
        >
      </canvas>
      <div class="absolute w-5 right-0 lg:right-20 -top-7" #legendDiv>
        <div style="margin-left: -16px">
          {{ getMinDate() | date : "shortDate" }}
        </div>
        <canvas
          class=""
          style="width: 100%"
          #legendCanvas
          [ngStyle]="{ height: legendDivHeight }"
        ></canvas>
        <div style="margin-left: -16px">
          {{ getMaxDate() | date : "shortDate" }}
        </div>
      </div>
    </div>

    <div class="filter-group">
      <form [formGroup]="settingsForm">
        <!-- Date Range Options -->
        <mat-form-field appearance="fill">
          <mat-label>{{ "app.displayTimePeriod" | translate }}</mat-label>
          <mat-select
            (selectionChange)="dateRangeSelectionChanged($event)"
            [formControl]="preDefinedDatePeriod"
            name="preDefinedDateField"
            data-test-id="module-date-range-select"
            >
            @for (timePeriod of selectableTimePeriods; track timePeriod) {
              <mat-option
                matInput
                [value]="timePeriod.value"
                >{{ timePeriod.viewValue }}</mat-option
                >
              }
            </mat-select>
          </mat-form-field>
          <!-- Selected Datasource -->
          <mat-form-field appearance="fill">
            <mat-label>Datenquelle</mat-label>
            <mat-select
              (selectionChange)="selectionChanged($event)"
              [formControl]="selectedFieldControl"
              name="selectedField"
              >
              @for (field of availableSensors | keyvalue; track field) {
                <mat-option
                  matInput
                  [value]="field.key"
                  >{{ field.value.display_name }}</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>

            <!-- Date Range Filter -->
            @if (customDateRange) {
              <mat-form-field
                [color]="'accent'"
                appearance="fill"
                >
                <mat-label>{{ "app.filterTimePeriod" | translate }}</mat-label>
                <mat-date-range-input
                  [formGroup]="settingsForm"
                  [rangePicker]="datepicker"
                  [min]="getMinDate()"
                  [max]="getMaxDate()"
                  >
                  <input
                    matStartDate
                    type="text"
                    matInput
                    formControlName="filterDateStart"
                    placeholder="dd.mm.yyyy"
                    (dateChange)="customDateFilterChanged($event)"
                    data-test-id="module-custom-date-start"
                    />
                  <input
                    matEndDate
                    type="text"
                    matInput
                    formControlName="filterDateEnd"
                    placeholder="dd.mm.yyyy"
                    (dateChange)="customDateFilterChanged($event)"
                    data-test-id="module-custom-date-end"
                    />
                </mat-date-range-input>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datepicker"
                ></mat-datepicker-toggle>
                <mat-date-range-picker #datepicker>
                  <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Schließen</button>
                    <button mat-raised-button color="primary" matDatepickerApply>
                      Auswählen
                    </button>
                  </mat-datepicker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            }
          </form>
        </div>
      </mat-card-content>
      @if (userService.userIsAdmin) {
        <mat-card-actions>
          <button
            mat-button
            (click)="reportModuleService.openEditReportModuleForm(config.guid)"
            >
            BEARBEITEN
          </button>
          <button
            (click)="reportModuleService.removeModuleFormReport(config.guid)"
            mat-button
            >
            LÖSCHEN
          </button>
        </mat-card-actions>
      }
    </mat-card>
